import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { getLocalTracks, isLocalTrackMuted } from '../../../react/features/base/tracks/functions.any';
// @ts-ignore
import { WIS_RPC_COMMANDS } from './constants';
// @ts-ignore
import sendWisHeadsetStatus from './helpers/sendWisHeadsetStatus';
StateListenerRegistry.register(
/* selector */ state => isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO), 
/* listener */ (muted, { getState }, prevMuted) => {
    const state = getState();
    const localTracks = getLocalTracks(state['features/base/tracks']);
    // @ts-ignore
    const { isConnected } = state['wildix/features/wiservice'];
    if (typeof prevMuted !== 'undefined' && isConnected && localTracks.length) {
        sendWisHeadsetStatus(APP.wildix.wiservice._socket, {
            command: WIS_RPC_COMMANDS.TALKING,
            mic: muted ? WIS_RPC_COMMANDS.MUTE : WIS_RPC_COMMANDS.UNMUTE
        });
    }
});
